import React, { useState } from 'react'
import { Button, Col, Drawer, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { assetHistotry } from '../../../redux/actions/addDurableArticles'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { doneLoading, startLoading } from '../../../utils/loading'
import { budgetFormat } from '../../../utils/formatterUtil'
import MiniProjectInfo from '../../projectBasedItemsWidget/MiniProjectInfo'
import AssetMigrationTable from './AssetMigrationTable'

export default function AssetMigrationWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [formSchema, setFormSchema] = useState(props.schema)
  const [isShowHistory, setIsShowHistory] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [historySchema, setHistorySchema] = useState()

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={formSchema.header} bordered>
        {/* {formSchema?.projectInfo && <MiniProjectInfo schema={formSchema?.projectInfo} />} */}

        <AssetMigrationTable
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          schema={formSchema?.form}
          isViewMode={!formSchema?.form?.isEnableEdit}
        />
      </Panel>
    </>
  )
}
